import type { TableRow } from "./atoms";
import { formatDecimal, formatPercent } from "./formatters";
import * as React from "react";
import * as strings from "./strings";

const {
  table_time_header,
  table_membercount_header,
  table_newmembers_header,
  table_fee_header
} = strings;
export const Table = React.forwardRef<
  HTMLTableElement,
  { tableRows: TableRow[] }
>(function Table(p, ref) {
  let tableRows = p.tableRows;
  if (tableRows.length === 0) {
    return null;
  }
  return (
    <table className="atc-table" ref={ref}>
      <thead className="atc-table__head">
        <th className="atc-table__head-item">{table_time_header}</th>
        <th className="atc-table__head-item">{table_membercount_header}</th>
        <th className="atc-table__head-item">{table_newmembers_header}</th>
        <th className="atc-table__head-item">{table_fee_header}</th>
      </thead>
      <tbody className="atc-table__body">
        {tableRows.map(tableRow => (
          <tr key={tableRow.date} className="atc-table__row">
            <td className="atc-table__row-item" data-th={table_time_header}>
              {tableRow.date}
            </td>
            <td
              className="atc-table__row-item"
              data-th={table_membercount_header}
            >
              {formatDecimal(Math.floor(tableRow.membersTotal))}
            </td>
            <td
              className="atc-table__row-item"
              data-th={table_newmembers_header}
            >
              {formatDecimal(Math.floor(tableRow.membersNew))}
            </td>
            <td className="atc-table__row-item" data-th={table_fee_header}>
              {formatPercent(tableRow.fee)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
});
